
module.exports = 
[{
    "group": "Customer",
    "selected": false,
    "name": "Main Menu",
    "base": true,
    "id": "main_menu",
    "icon": "shutter_speed",
    "list": [{
        "selected": true,
        "name": "BatteryPackList",
        "id": "battery_pack_list"
    }, 
    {
        "selected": true,
        "name": "CurrentStatus",
        "id": "current_status"
    }, 
    {
        "selected": true,
        "name": "Map",
        "id": "map"
    }],   
}]


// WEBPACK FOOTER //
// ./src/core/routes.js